import classNames from "classnames";
import React, { ImgHTMLAttributes, useMemo } from "react";

import { environment } from "~/environment";
import { DefaultImage } from "~/images";

export enum ImageVariant {
  Public = "public",
  SmallThumbnail = "smThumb",
  MediumThumbnail = "mdThumb",
  LargeThumbnail = "lgThumb",
  XLThumbnail = "xlThumb",
  PlayerCard = "playerCard",
}

export interface CDNImageProps extends Omit<ImgHTMLAttributes<never>, "src"> {
  alt?: string;
  variant?: ImageVariant;
  imageId?: string;
  isCdn?: boolean;
}

export const CDNImage: React.FC<CDNImageProps> = ({
  alt,
  imageId,
  variant = ImageVariant.Public,
  className,
  isCdn = true,
  ...restProps
}) => {
  const url = useMemo(() => {
    if (imageId) {
      if (isCdn) {
        return `${environment.CDN_URI}${imageId}/${variant}`;
      } else {
        return `${environment.DIGITAL_OCEAN_URI}${imageId}`;
      }
    } else {
      return null;
    }
  }, [imageId, isCdn, variant]);

  const usedAlt = useMemo(() => alt || imageId?.substring(0, 5), [
    alt,
    imageId,
  ]);
  return url ? (
    <img src={url} alt={usedAlt} className={className} {...restProps} />
  ) : (
    <img
      src={DefaultImage}
      {...restProps}
      alt="default"
      className={classNames(className, `variant-${variant}`)}
    />
  );
};
